import React, { useEffect, useState } from "react";
//import workerAPI from "../api/workerAPI";
import { FaTimes } from "react-icons/fa";
import attendanceAPI from "../api/attendanceAPI";


const WorkerSidebar = ({ isOpen, onClose }) => {
  const [workers, setWorkers] = useState([]);

  useEffect(() => {
    if (isOpen) {
      fetchWorkers();
    }
  }, [isOpen]);

  const fetchWorkers = async () => {
    try {
      console.log("📤 Fetching workers...");

      const res = await attendanceAPI.get("/allpeo");

      console.log("✅ Workers Data:", res.data);

      if (Array.isArray(res.data)) {
        setWorkers(res.data);
      } else {
        setWorkers([]);
      }
    } catch (err) {
      console.error("❌ Fetch error:", err);
      console.error("❌ Server:", err.response?.data);
    }
  };

  // 🎯 Status UI
  const getStatusUI = (status, lastSeen) => {
    switch (status) {
      case "online":
        return (
          <span className="flex items-center gap-1 text-green-600 text-xs font-medium">
            <span className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></span>
            Online
          </span>
        );

      case "idle":
        return (
          <span className="flex items-center gap-1 text-yellow-600 text-xs font-medium">
            <span className="text-sm">🌙</span>
            Idle
          </span>
        );

      default:
        return (
          <span className="flex items-center gap-1 text-gray-500 text-xs font-medium">
            <span className="w-2 h-2 bg-gray-400 rounded-full"></span>
            {lastSeen
              ? `Offline (${new Date(lastSeen).toLocaleTimeString([], {
                  hour: "2-digit",
                  minute: "2-digit",
                })})`
              : "Offline"}
          </span>
        );
    }
  };

  // Group workers by role
  const grouped = workers.reduce((acc, worker) => {
    if (!worker.role) return acc;
    acc[worker.role] = acc[worker.role] || [];
    acc[worker.role].push(worker);
    return acc;
  }, {});

  return (
    <div
      className={`fixed top-0 right-0 h-full w-80 bg-white shadow-2xl z-50 transform ${
        isOpen ? "translate-x-0" : "translate-x-full"
      } transition-transform duration-300`}
    >
      {/* 🔥 HEADER */}
      <div className="flex justify-between items-center p-4 border-b bg-gradient-to-r from-blue-500 to-indigo-600 text-white">
        <h2 className="font-bold text-lg">👥 Workers</h2>
        <FaTimes
          className="cursor-pointer hover:text-red-300"
          onClick={onClose}
        />
      </div>

      {/* 📋 LIST */}
      <div className="p-3 overflow-y-auto h-full">
        {workers.length === 0 && (
          <p className="text-center text-gray-400 mt-5">
            No workers found 😢
          </p>
        )}

        {Object.keys(grouped).map((role) => (
          <div key={role} className="mb-4">
            {/* Role Title */}
            <h3 className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-2">
              {role}
            </h3>

            {grouped[role].map((w) => (
              <div
                key={w._id}
                className="flex items-center justify-between px-3 py-2 rounded-lg hover:bg-blue-50 transition-all duration-200"
              >
                {/* Left */}
                <div className="flex items-center gap-2">
                  {/* Avatar */}
                  <div className="w-8 h-8 rounded-full bg-blue-100 flex items-center justify-center text-sm font-bold text-blue-700">
                    {w.username?.charAt(0).toUpperCase()}
                  </div>

                  {/* Name */}
                  <span className="text-sm font-medium text-gray-800">
                    {w.username}
                  </span>
                </div>

                {/* Right Status */}
                {getStatusUI(w.status, w.lastSeen)}
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default WorkerSidebar;